/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import './reportAnswerMatchPair.scss';
import {IMatchPairsReport} from '../../../../analytics';

interface ReportAnswerPercentageProps {
    matchPairReport: IMatchPairsReport;
}

function ReportAnswerMatchPair(props: ReportAnswerPercentageProps): JSX.Element {
    const {matchPairReport} = props;

    const {leftLabels, labelMatrix} = matchPairReport;

    const refinedData = leftLabels.map((leftLabel) => {
        const correctRightLabels = Object.entries(labelMatrix[leftLabel])
            .filter(([_, data]) => {
                return data.correct;
            })
            .map(([rightLabel, _]) => rightLabel);

        const correctAnswersCount = Object.entries(labelMatrix[leftLabel])
            .filter((el) => el[1].correct)
            .reduce((acc, el) => acc + el[1].count, 0);

        const totalAnswersCount = Object.entries(labelMatrix[leftLabel]).reduce((acc, el) => acc + el[1].count, 0);

        return {left: leftLabel, right: correctRightLabels, correctAnswersCount, totalAnswersCount};
    });

    function truncatePercentage(value: number): number {
        if (Number.isNaN(value)) return 0;
        return Math.round(value * 10 * 100) / 10;
    }

    return (
        <div className="c-reportAnswerMatchPair">
            {refinedData.map((el, leftIndex) =>
                el.right.map((rightLabel, rightIndex) => (
                    <div className="c-reportAnswerMatchPair__row" key={`${leftIndex}-${rightIndex}`}>
                        <div className="c-reportAnswerMatchPair__item">{el.left}</div>
                        <div className="c-reportAnswerMatchPair__item">{rightLabel}</div>
                        <div className="c-reportAnswerMatchPair__percentage">
                            {truncatePercentage(el.correctAnswersCount / el.totalAnswersCount)}%
                        </div>
                    </div>
                ))
            )}
        </div>
    );
}
export default ReportAnswerMatchPair;
